import { render, staticRenderFns } from "./headerPageVertical.vue?vue&type=template&id=5a679aaf&scoped=true&"
import script from "./headerPageVertical.vue?vue&type=script&lang=js&"
export * from "./headerPageVertical.vue?vue&type=script&lang=js&"
import style0 from "./headerPageVertical.vue?vue&type=style&index=0&id=5a679aaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a679aaf",
  null
  
)

export default component.exports